var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20785",
    "data-name": "Group 20785",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9941",
    "data-name": "Rectangle 9941",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cross_2_",
    "data-name": "cross (2)",
    d: "M13.829.171h0a.583.583,0,0,0-.825,0l-6,6-6-6a.583.583,0,0,0-.825,0h0A.583.583,0,0,0,.171,1l6,6-6,6a.583.583,0,0,0,0,.825h0a.583.583,0,0,0,.825,0l6-6,6,6a.583.583,0,0,0,.825,0h0a.583.583,0,0,0,0-.825l-6-6,6-6a.583.583,0,0,0,0-.825Z",
    transform: "translate(1 1)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1bb2c710c60e4ae6e0184182ed92f514.svg";
export { ForwardRef as ReactComponent };